export const environment = {
  production: true,
  defaultLanguage: 'en',
  selectedLanguage: 'en',
  supportedLanguages: ['en', 'es'],
  //baseUrl: 'https://testintercessorylivingwd.azurewebsites.net/api/', //
  baseUrl: 'https://intercessory.livingwd.org/api/',
  // baseUrl: 'https://intercessory-sp.livingwd.org/api/', //
  //baseUrl: 'https://bwmicp-5id63zeigytdf.billwinston.org/api/', //
  courseId: 1,
  courseStructure: {
    totalClasses: 10,
    activitiesPerClass: 3, // video, handout, quiz
    get totalActivities() { return this.totalClasses * this.activitiesPerClass; }
  },
  translationConfig: {
    fallbackLanguage: 'en',
    enableBrowserLanguageDetection: true,
    enableLocalStorage: true,
    translationPath: './assets/i18n/',
    translationSuffix: '.json'
  },
  courseSettings: {
    // Production: 7 days waiting period between classes
    classCooldownPeriod: {
      days: 7,
      hours: 0, // 7 days * 24 hours
      minutes: 0 // 7 days * 24 hours * 60 minutes
    },
  },
  classManual: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/',
  classFAQ: 'https://online.fliphtml5.com/qubm/bklt/#p=1',
  classDocuments: {
    Class1: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class2: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class3: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class4: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class5: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class6: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class7: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class8: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class9: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    },
    Class10: {
      documentUrl: 'https://online.fliphtml5.com/qubm/2026_Intercessory_Prayer_Handbook/'
    }
  }
};
